import { Option } from './option';
export enum TimezoneEnum {
    USER='USER_TIMEZONE',
    STATION='STATION_TIMEZONE'
}

export namespace TimezoneEnum {
    export function getOptions(): Option<TimezoneEnum>[] {
        return [
            { name: 'Station Timezone', value: TimezoneEnum.STATION },
            { name: 'My Timezone', value: TimezoneEnum.USER }
        ];
    }
}